import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthShell, Field } from "./AuthShell";
import { TwoFactorStep } from "./TwoFactorStep";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const finish = (u) => {
    toast.success("Welcome back!");
    const dest = u.role === "admin" || u.role === "super_admin" ? "/admin" : (loc.state?.from?.pathname || "/dashboard");
    nav(dest, { replace: true });
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password);
      if (r.requires_2fa) { setChallenge(r); return; }
      finish(r);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  if (challenge) return <TwoFactorStep challenge={challenge} onSuccess={finish} onCancel={() => setChallenge(null)} />;

  return (
    <AuthShell title="Welcome back" subtitle="Log in to your AI TECHNOLOGY account"
      footer={<>Don't have an account? <Link to="/signup" className="text-cyan-400 hover:underline" data-testid="login-to-signup">Create Account</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="Email" testId="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        <Field label="Password" testId="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-xs text-cyan-400 hover:underline" data-testid="login-forgot-link">Forgot Password?</Link>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="btn-glow w-full py-3 rounded-lg font-semibold text-slate-950 inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Login
        </button>
      </form>
    </AuthShell>
  );
}
